import React from "react";

export default ({ history }) => {
	const goToPage = (url) => {
		history.push(`/${url}`);
	};
	return (
		<div className="row mb-4">
			<div className="col-6 pr-1">
				<button className="w-100 btn btn-primary-dark btn-ghost" onClick={() => goToPage("request-information")}>
					<i className="md-icon mr-2 icon icon-ask" />
					Request Information
				</button>
			</div>
			<div className="col-6 pl-1">
				<button className="w-100 btn btn-primary-dark btn-ghost" onClick={() => goToPage("schedule-an-appointment")}>
					<i className="md-icon mr-2 icon icon-appointment" />
					Schedule an appointment
				</button>
			</div>
		</div>
	);
};
